
import { useToast as useToastOriginal, toast as toastOriginal } from "@/hooks/use-toast";

// Re-export with additional functionality
export const useToast = useToastOriginal;
export const toast = toastOriginal;

// Export default to maintain compatibility
export default { useToast: useToastOriginal, toast: toastOriginal };
